'use client';

import Link from 'next/link';

import { UserRound } from 'lucide-react';

import { PersonalAccountDropdown } from '@kit/accounts/personal-account-dropdown';
import { useSignOut } from '@kit/supabase/hooks/use-sign-out';
import { JWTUserData } from '@kit/supabase/types';
import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

import pathsConfig from '~/config/paths.config';

import pearlStyles from './website-pearl-button.module.css';

const paths = {
  home: pathsConfig.app.home,
};

const features = {
  enableThemeToggle: false,
};

export function SiteHeaderAccountSection({
  user,
}: {
  user: JWTUserData | null;
}) {
  const signOut = useSignOut();

  if (user) {
    return (
      <PersonalAccountDropdown
        showProfileName={false}
        paths={paths}
        features={features}
        user={user}
        signOutRequested={() => signOut.mutateAsync()}
      />
    );
  }

  return <AuthButtons />;
}

function AuthButtons() {
  return (
    <div className={'flex items-center gap-x-1 sm:gap-x-2.5'}>
      <div className="flex items-center gap-x-1 sm:gap-x-2.5">
        <Link
          href={pathsConfig.auth.signIn}
          aria-label="Sign in"
          title="Sign in"
          className="inline-flex h-11 w-11 items-center justify-center rounded-full hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <UserRound size={20} aria-hidden />
        </Link>

        <Button
          asChild
          className={`${pearlStyles.pearl} website-signup-glass`}
          variant="default"
        >
          <Link
            href={pathsConfig.auth.signUp}
            data-website-button="default"
            data-button-tone="accent"
          >
            <Trans i18nKey="auth:signUp" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
